import { appConfig } from '@/config/app.ts'

export interface PublicityState {
  isLoading: boolean
  isCreateModalOpen: boolean
  editId: number | null
  filters: string
}

export const initialState: PublicityState = {
  isLoading: false,
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}